'use strict';

module.exports = {
    init: function () {
        var slides = $('.product-tile.portfolio.has-modal');
        var pageUrl = $('.container.search-results').data('pageUrl');
        var pageName = $('.container.search-results').data('pageName');

        slides.each(function (index) {
            var modalData = $(this).data('modalData'),
                hasFb = modalData.facebook_label,
                hasEmail = modalData.email_label,
                hasPinterest = modalData.pinterest_label && modalData.image,
                fbMobileString = hasFb ? '<a href="' + pageUrl + '" title="' + modalData.facebook_label + '" data-share="mobile" class="share-icons mobile d-md-none" target="_blank">'
                + '<i class="icon-cms-mobile-share" title="Facebook"></i>'
                + '</a>' : '',
                fbString = hasFb ? '<a href="https://www.facebook.com/share.php?u=' + pageUrl + '" title="' + modalData.facebook_label + '" data-share="facebook" aria-label="' + modalData.facebook_label + '" class="share-icons" target="_blank">'
                + '<i class="icon-cms-facebook-share" title="Facebook"></i>'
                + '</a>' : '',
                emailString = hasEmail ? '<a href="mailto:?subject=' + pageName + ' | The Urban Electric Company&body=' + pageUrl + '" title="' + modalData.email_label + '" data-share="email" aria-label="' + modalData.email_label + '" class="share-icons" target="_blank">'
                + '<i class="icon-cms-email-share" title="Email"></i>'
                + '</a>' : '',
                pinterestString = hasPinterest ? '<a href="https://pinterest.com/pin/create/button/?url=' + pageUrl + (modalData.subtitle ? ('&description=' + modalData.subtitle) : '') + (modalData.image ? ('&media=' + modalData.image) : '') + '" title="' + modalData.pinterest_label + '" aria-label="' + modalData.pinterest_label + '" class="share-icons" target="_blank">'
                + '<i class="icon-cms-pinterest-share" title="Pinterest"></i>'
                + '</a>' : '';

            var html = ''
                + '<div class="gallery-slide">'
                + '<div class="gallery-image-container">'
                + '<img class="content-image" src="' + modalData.image + '"' + (modalData.image_alt ? ('alt="' + modalData.image_alt + '"') : '') + (modalData.image_title ? ('title="' + modalData.image_title + '"') : '') + '/>'
                + '</div>'
                + '<div class="col modal-subtitle">'
                + '<p class="text-center">' + (modalData.subtitle ? modalData.subtitle : '') + '</p>'
                + '</div>'
                + '<div class="bottom-content">'
                + '<div class="col count-social">'
                + '<div class="slide-count">'
                + '<span class="current-slide">' + (index + 1) + '</span>'
                + '/'
                + '<span class="upper-limit">' + slides.length + '</span>'
                + '</div>'
                + '<div class="col view-more">'
                + '<p class="text-center view-more-link">' + (modalData.details_link ? '<a href="' + modalData.details_link + '">View Details</a>' : '') + '</p>'
                + '</div>'
                + '<div class="social">'
                + '<div class="col-12 social-container">'
                + '<span class="social-icons-label">Share</span>'
                + '<span class="social-icons">'
                + fbMobileString
                + emailString
                + fbString
                + pinterestString
                + '</span>'
                + '</div>'
                + '</div>'
                + '</div>'
                + '</div>'
                + '</div>';

            $('.js-portfolio-slider').append(html);
        });

        $(document).on('click', '.share-icons.mobile', function (e) {
            e.preventDefault();
            var $this = $(this);
            if (navigator.share) {
                navigator.share({
                    title: 'Urban Elctric Co',
                    url: $this.attr('href')
                });
            }
        });

        var slideIndex = 0;

        $(document).on('click', '.product-tile.portfolio a', function (e) {
            e.preventDefault();
            var $parent = $(this).closest('.product-grid');
            var $container = $(this).closest('.experience-component');
            slideIndex = $parent.find('.experience-component').index($container);

            $('#portfolio-modal').modal('show');
        });

        $('#portfolio-modal').on('shown.bs.modal', function () {
            $('.js-portfolio-slider').css({ visibility: 'visible' }).slick({ initialSlide: slideIndex, speed: 1, mobileFirst: true, fade: true, responsive: [{ breakpoint: globalConfig.bp.large, settings: { swipe: false } }] });
        });

        $('#portfolio-modal').on('hidden.bs.modal', function () {
            $('.js-portfolio-slider').css({ visibility: 'hidden' }).slick('unslick');
        });
    }
};
